import React, { useContext, useRef } from "react";
import ActionsContext from "common/ActionsContext";
import { loadFile } from "common/FileInput";
import LicenseHelpModal from "./Help";
import LicenseReport from "./Report";
import InstallModal from "./InstallModal";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  const fileInputRef = useRef(null);

  const handleLoadClick = () => {
    fileInputRef.current.click();
  };

  const handleSaveFile = (response, remotePath) => {
    if (response.SaveAsFileResponse.code !== 0) {
      showModalError("Error saving file", response.SaveAsFileResponse.reason);
    } else {
      ifCl
        .run(`set license load ${remotePath}`)
        .then((response) => {
          if (response === "") {
            actions.send("open-install")
          } else {
            showModalError(
              "Error loading license",
              response.CmdResponse.response
            );
          }
        })
        .catch((error) => {
          showModalError("Error loading license", error);
        });
    }
  };

  const handleFileChange = (event) => {
    const [file] = event.target.files;
    if (file) {
      const remotePath = `/tmp/lic_${Math.random().toString(36).substring(5)}`;
      loadFile(file).then((response)=>{
        ifCl.saveAsFile(response, remotePath, (res)=>handleSaveFile(res, remotePath))
      })
    }
  };

  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li key="menu-open-help">
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => actions.send("open-help")}
        >
          <i className="material-icons">help_outline</i>
        </a>
      </li>
      <li key="menu-refresh">
        <a
          onClick={() => actions.send("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
      <li className="dropdown hidden-to-operators" key="menu-dropdown">
        <a
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          title="Options"
        >
          <i className="material-icons">more_vert</i>
        </a>
        <ul className="dropdown-menu pull-right">
          <li key="menu-add-rule">
            <a onClick={handleLoadClick}>Load...</a>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </li>
        </ul>
      </li>
    </ul>
  );
};

const License = () => {
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <div className="header block-header">
          <h2 className="title">License Status</h2>
          <ContextMenu />
        </div>
        <LicenseReport />
        <LicenseHelpModal />
        <InstallModal />
      </div>
    </div>
  );
};

export default License;
